module.exports = __webpack_public_path__ + "img/choose-box.db6513ad.png";